import { Globe } from "lucide-react";
import { LANGUAGES } from "../translations";

export const LanguageSwitcher = ({ lang, onChange }) => (
  <div className="flex items-center gap-1" data-testid="language-switcher">
    <Globe className="w-4 h-4 text-gray-400 mr-1" />
    <div className="flex rounded-full border border-gray-200 bg-gray-50 p-0.5">
      {LANGUAGES.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => onChange(l.code)}
          aria-label={l.name}
          aria-pressed={lang === l.code}
          className={`px-3 py-1 text-xs font-semibold rounded-full transition-colors ${
            lang === l.code
              ? "bg-[#FF6600] text-white shadow-sm"
              : "text-gray-600 hover:text-[#FF6600]"
          }`}
          data-testid={`lang-${l.code}`}
        >
          {l.label}
        </button>
      ))}
    </div>
  </div>
);
